<template>
    <div class="ZhiJi">
  <ul>
      <li><img src="@/assets/image/yi.png" alt=""></li>
      <li class="yi"><img src="@/assets/image/er.png" alt=""></li>
      <li><img src="@/assets/image/san.png" alt=""></li>
      <li class="yi"><img src="@/assets/image/si.png" alt=""></li>
      <li><img src="@/assets/image/wu.png" alt=""></li>
  </ul>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.ZhiJi{
    box-sizing: border-box;
}

ul li{
    width: 450px;
    height: 800px;
   float: left;
}

</style>